module.exports = __webpack_public_path__ + "static/media/card-logo-3.8092c432.svg";